import {Icon, IconProps} from '@chakra-ui/react';

export const StopwatchIcon = (props: IconProps) => (
  <Icon width="16px" height="19px" viewBox="0 0 16 19" fill="none" color="white" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 1C5 0.44772 5.44772 0 6 0H10C10.5523 0 11 0.44772 11 1C11 1.55228 10.5523 2 10 2H9V3.06189C12.9463 3.55399 16 6.92038 16 11C16 15.4183 12.4183 19 8 19C3.58172 19 0 15.4183 0 11C0 6.92038 3.05369 3.55399 7 3.06189V2H6C5.44772 2 5 1.55228 5 1ZM11.7071 7.29289C12.0976 7.68342 12.0976 8.3166 11.7071 8.7071L9.9323 10.482C9.9764 10.6472 10 10.8208 10 11C10 12.1046 9.1046 13 8 13C6.8954 13 6 12.1046 6 11C6 9.8954 6.8954 9 8 9C8.1792 9 8.3528 9.0236 8.518 9.0677L10.2929 7.29289C10.6834 6.90237 11.3166 6.90237 11.7071 7.29289Z"
      fill="currentColor"
    />
    <path
      d="M2.77143 2.47372C2.48322 2.00374 1.86535 1.85285 1.42342 2.18248C1.03337 2.4734 0.663062 2.78988 0.314922 3.12984C-0.0795277 3.51502 -0.0267476 4.14885 0.392592 4.50677C0.811932 4.86468 1.43855 4.81015 1.84067 4.43299C2.04299 4.24323 2.25398 4.06291 2.47295 3.89262C2.90815 3.55418 3.05965 2.94371 2.77143 2.47372Z"
      fill="currentColor"
    />
    <path
      d="M13.2285 2.47372C13.5167 2.00374 14.1346 1.85285 14.5765 2.18248C14.9666 2.4734 15.3369 2.78988 15.685 3.12984C16.0795 3.51502 16.0267 4.14885 15.6074 4.50677C15.188 4.86468 14.5614 4.81015 14.1593 4.43299C13.957 4.24323 13.746 4.06291 13.527 3.89262C13.0918 3.55418 12.9403 2.94371 13.2285 2.47372Z"
      fill="currentColor"
    />
  </Icon>
);
